// extracted by mini-css-extract-plugin
export default {"card":"summary-card_card__WaCWj","icon":"summary-card_icon__T8W7v","title":"summary-card_title__vtkAm"};